export const makeLocalStorageAdapter = (key: string) => ({
  key,
  get: () => localStorage.getItem(key),
  set: (value: string) => localStorage.setItem(key, value),
});
